<template>
  <b-card no-body>
    <b-card-header class="align-items-baseline">
      <div class="w-100">
        <b-card-title>
          <slot name="title"></slot>
        </b-card-title>
        <!-- <b-card-text class="mb-0"> Last 6 months </b-card-text> -->
      </div>
    </b-card-header>
    <b-card-body>
      <vue-apex-charts
        v-if="isRenderingChart"
        type="bar"
        height="400"
        :options="chartOptions"
        :series="chartOptions.series"
      />
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  props: {
    getChartData: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    let _this = this;
    this.getChartData(_this);
  },
  data() {
    return {
      chartOptions: {
        series: [
          {
            data: [],
          },
        ],
        tooltip: {
          y: {
            title: {
              formatter: (seriesName) => " تعداد جلسات: ",
            },
          },
        },
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function (chart, w, e) {
              // console.log(chart, w, e)
            },
          },
        },
        colors: ["#215698"],
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: ["#215698"],
              fontSize: "12px",
              fontFamily: "IranSans",
            },
          },
        },
      },
      chartPayload: {
        pageNumber: 1,
        count: 8,
      },
      isRenderingChart: false,
    };
  },
  methods: {
    renderChart() {
      this.isRenderingChart = true;
    },
  },
  components: {
    VueApexCharts,
    BDropdown,
    BDropdownItem,
    BCardText,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
};
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
</script>
